<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <div>
        <v-dialog v-model="dialogLocal" @keydown.esc="closeDialog" max-width="640px">
            <v-card>
                <v-card-title>
                    <span class="headline" align="center" style="color:#FFFD00;background-color:#363636;width:100%;display:block;">Org HTTP Endpoint Data</span>
                </v-card-title>
                <v-card-text>
                    <v-progress-linear v-if="waiting" :indeterminate="true"/>
                    <v-row>
                        <v-col md="10">
                            <v-text-field
                                    v-model="localOrgData.httpEndpoint"
                                    label="Http Endpoint"
                                    :clearable=true>
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col md="10">
                            <v-text-field
                                v-model="localOrgData.id"
                                label="Org ID"
                                readonly>
                            </v-text-field>
                        </v-col>
                        <v-col md="2">
                            <v-btn @click="copyToClipBoard(localOrgData.id)">
                                <v-icon>mdi-content-copy</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col md="10">
                            <v-text-field
                                v-model="privateKeyUrl"
                                label="Private Key URL"
                                readonly>
                            </v-text-field>
                        </v-col>
                        <v-col md="2">
                            <v-btn @click="copyToClipBoard(privateKeyUrl)">
                                <v-icon>mdi-content-copy</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col md="10">
                            <v-textarea
                                v-model="privateKey"
                                placeholder="Private Key"
                                outlined
                                readonly
                                single-line
                                no-resize/>
                        </v-col>
                        <v-col md="2">
                            <v-btn @click="copyToClipBoard(privateKey)">
                                <v-icon>mdi-content-copy</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col xs="12">
                            <v-btn :color="endPointButtonColor" class="white--text" :disabled="waiting" @click="setEndpointKeysRequest()">Set Endpoint Keys</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="mr-2">
                    <v-spacer/>
                    <v-btn color="blue darken-1" text @click="closeDialog">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <ConfirmationDialog v-if="confirmNewKeyPair" :params="confirmNewKeyPairParams" @confirmation-dialog-response="confirmNewKeyPairHandler"></ConfirmationDialog>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import ConfirmationDialog from '@/components/confirmation-dialog';

    export default
    {
        name: 'org-http-endpoint-dialog',
        components:
        {
            ConfirmationDialog
        },
        data: function ()
        {
            return {
                dialogLocal: false,
                localOrgData: {},
                confirmNewKeyPair: false,
                confirmNewKeyPairParams:
                {
                    title: 'Generate New Key Pair',
                    text: '',
                    positiveResponse: 'Yes',
                    negativeResponse: 'No',
                    context: ''
                }
            }
        },
        props:
        {
            dialog: false,
            editedIndex: {}
        },
        computed:
        {
            ...mapState('orgs',
            {
                orgs: state => state.orgs,
                endpointKeysVerified: state => state.endpointKeysVerified,
                privateKey: state => state.privateKey,
                privateKeyUrl: state => state.privateKeyUrl
            }),
            ...mapState('common',
            {
                waiting: state => state.waiting
            }),
            endPointButtonColor()
            {
                return this.endpointKeysVerified ? 'green' : 'red'
            }
        },
        watch:
        {
            dialogLocal(val)
            {
                // If the dialog is being closed
                if (!val)
                {
                    this.$emit('dialog-close');
                    this.SET_PRIVATE_KEY(null)
                    this.SET_PRIVATE_KEY_URL(null)
                }
                else // Else the dialog is being open
                {
                    this.localOrgData = this.orgs[this.editedIndex];
                    this.localOrgData.httpEndpoint = this.localOrgData.httpEndpoint ? this.localOrgData.httpEndpoint : '';
                    this.verifyEndpointKeys()
                }
            },
            dialog(val)
            {
                this.dialogLocal = val;
                this.httpEndpoint = ''
            }
        },
        methods:
        {
            ...mapMutations('common', ['WAITING', 'SHOW_SNACKBAR_ERROR', 'HIDE_SNACKBAR']),
            ...mapMutations('orgs', ['SET_PRIVATE_KEY', 'SET_PRIVATE_KEY_URL']),
            ...mapActions('orgs', ['SET_ORG', 'SET_ENDPOINT_KEYS', 'VERIFY_ENDPOINT_KEYS']),
            closeDialog()
            {
                this.$emit('dialog-close')
            },
            async verifyEndpointKeys()
            {
                try
                {
                    this.HIDE_SNACKBAR();
                    this.WAITING(true);
                    await this.VERIFY_ENDPOINT_KEYS(this.localOrgData.id)
                }
                catch (error)
                {
                    this.SHOW_SNACKBAR_ERROR(error.message)
                }
                this.WAITING(false)
            },
            async setEndpointKeysRequest()
            {
                // If there is already a key pair, have the user confirm to create a new pair
                if (this.endpointKeysVerified)
                {
                    this.confirmNewKeyPair = true;
                    return
                }
                await this.setEndpointKeys()
            },
            async confirmNewKeyPairHandler(payload)
            {
                this.confirmNewKeyPair = false;
                // If the new key pair should be generated
                if (payload.response)
                {
                    await this.setEndpointKeys()
                }
            },
            async setEndpointKeys()
            {
                try
                {
                    this.HIDE_SNACKBAR();
                    this.WAITING(true);
                    await this.SET_ENDPOINT_KEYS(this.localOrgData.id)
                }
                catch (error)
                {
                    this.SHOW_SNACKBAR_ERROR(error.message)
                }
                this.WAITING(false)
            },
            async save()
            {
                try
                {
                    this.HIDE_SNACKBAR();
                    this.WAITING(true);
                    await this.SET_ORG({editedIndex: this.editedIndex, data: this.localOrgData});
                    this.$emit('dialog-close')
                }
                catch (error)
                {
                    this.SHOW_SNACKBAR_ERROR(error.message)
                }
                this.WAITING(false)
            },
            copyToClipBoard(textToCopy)
            {
                navigator.clipboard.writeText(textToCopy)
            }
        }
    };
</script>

<style scoped>

</style>